var render, staticRenderFns
import script from "./PartnerLogos.vue?vue&type=script&lang=js&"
export * from "./PartnerLogos.vue?vue&type=script&lang=js&"
import style0 from "./PartnerLogos.vue?vue&type=style&index=0&id=f4cb8146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cb8146",
  null
  
)

export default component.exports